import {
    CLEAR_STATE,
    GET_CERTIFICATE_INFO,
    GET_CERTIFICATE_STATUS,
    GET_CERTIFICATE_TYPES,
    GET_CERTIFICATES,
    GET_CRL_REASONS, GET_NEW_REQUEST_FIELDS
} from "../types";

const INITIAL_STATE = {
    certs:[],
    crlReasons:[]
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_CERTIFICATES:
            return {...state, ...action.payload};
        case GET_CERTIFICATE_INFO:
            return {...state, ...action.payload};
        case GET_NEW_REQUEST_FIELDS:
            return {...state, ...action.payload};
        case GET_CERTIFICATE_TYPES:
            return {...state, ...action.payload};
        case GET_CRL_REASONS:
            return {...state, ...action.payload};
        case GET_CERTIFICATE_STATUS:
            return {...state, ...action.payload};
        case CLEAR_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};